
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Previous from "../../Components/Info/Previous"
import Upcoming from "../../Components/Info/Upcoming"
import Styles from "../../Styles/interview.module.css"
import TopBar from "../../Components/LayoutWapper/Global/TopBar";
import Sidebar from "../../Components/LayoutWapper/Global/SideBar";



function Index() {
     
  const [activeTab, setActiveTab] = useState("tab1");

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  function toggleSidebar() {
    setIsSidebarOpen(!isSidebarOpen);
  }

  // handle tab switching
  const handleTab1 = () => {
    setActiveTab("tab1");
  };

  const handleTab2 = () => {
    setActiveTab("tab2");
  };



  return  (
      <div className={Styles.container}>
      <TopBar toggleSidebar={toggleSidebar}/>
      <div className={Styles.main} >
       <div className={Styles.context} >
       <div className={Styles.nav}>
       {isSidebarOpen && <Sidebar />}
       </div>
       <div className={Styles.center}>
        <div className={Styles.info}>
        <Link to='/resume' style={{ textDecoration:"none", color:"black"}}> 

        </Link>  
        <div className={Styles.Header}>
         <h1>Interviews</h1> 
        </div> 
        <div className={Styles.interviewcontainer}>
          <ul className={Styles.navcontainer}>
            <li  className={activeTab === "tab1" ? Styles.active : ""}
            onClick={handleTab1}
            id={Styles.tab1}
            >
                
            <h3>Upcoming</h3>
            </li>
            <li  className={activeTab === "tab2" ? Styles.active : ""}
            onClick={handleTab2}
            id={Styles.tab2}
            
            >
             
            <h3>Previous</h3>
            </li>
          </ul>
          <div className={Styles.outlet}>
          {/* content goes here */}
          {activeTab === "tab1" ? <Upcoming/> : <Previous />} 
        </div>
        </div>
        </div>
          </div>
       </div>
      </div>
      </div>
  )
}

export default Index;